import React from "react";

/*eslint-disable */

declare const window: any;
const TitleComponent: React.FC = () => {
  return (
    <h1 className="title-politicas-component">Aviso de privacidad</h1>
  );
};

export default TitleComponent;
